import React from 'react'
import { TransitionGroup } from 'react-transition-group'

const AnimateHOC = <WrappedProps extends {}>(
  WrappedComponent: React.ComponentType<Omit<WrappedProps, 'isVisible'>>,
) => {
  type Props = WrappedProps & {
    isVisible?: boolean
  }

  const AnimatedHOC: React.FC<Props> = props => {
    // If possible, we want to avoid passing isVisible to children blindly as it may end up in the DOM component
    const { isVisible, ...restProps } = props

    return (
      <TransitionGroup appear={isVisible} component={null}>
        {isVisible && <WrappedComponent {...restProps} />}
      </TransitionGroup>
    )
  }

  return AnimatedHOC
}

export default AnimateHOC
